import { DEFAULT_PINNED_VIEWS_QUERY_NAME } from '../portalViews/hooks/useGetPortalDefaultViews';
import { SingleViewByIdQuery } from '../singleView/hooks/useFetchSingleView';
import { VIEWS_SEARCH_QUERY_NAME } from '../viewsSearch/hooks/useFetchViewsSearch';
import { ViewsByCategorySearchQueries, getViewsByCatagoryQueryNameForCategory } from '../standardViews/hooks/useFetchViewsByCategory';
import { SupportedCategories, VIEW_CATEGORY_MINE } from '../addView/ViewCategories';
import { CREATE_SINGLE_VIEW_MUTATION_NAME } from '../createView/hooks/useCreateSingleViewMutation';
import { DEFAULT_PINNED_VIEW_QUERY_NAME } from '../pinnedViews/hooks/useFetchDefaultPinnedView';
export const mergeUnique = ({
  existing,
  incoming
}) => {
  if (!(existing !== null && existing !== void 0 && existing.length)) {
    return incoming;
  }
  if (!(incoming !== null && incoming !== void 0 && incoming.length)) {
    return existing;
  }
  const existingMap = new Map(existing.map(view => [view.id, view]));
  const incomingMap = new Map(incoming.map(view => [view.id, view]));
  const uniqueIdOrder = [...new Set([...existing.map(({
    id
  }) => id), ...incoming.map(({
    id
  }) => id)])];

  // If there is any overlap between existing and incoming,
  // maintain the order in existing
  // but prefer the incoming data as it is more up to date
  const merged = uniqueIdOrder.map(id => incomingMap.get(id) || existingMap.get(id)).filter(x => Boolean(x));
  return merged;
};
const viewsByCategoryKeyArgs = ['query', 'objectTypeId', 'namespace'];
export const mutationFieldPolicies = {
  [CREATE_SINGLE_VIEW_MUTATION_NAME]: {
    merge(__, incoming, {
      cache
    }) {
      cache.updateQuery({
        query: ViewsByCategorySearchQueries[VIEW_CATEGORY_MINE],
        variables: {
          objectTypeId: incoming.objectTypeId,
          query: '',
          category: VIEW_CATEGORY_MINE,
          namespace: incoming.namespaceName
        }
      }, data => {
        const currentViewsByCategory = data === null || data === void 0 ? void 0 : data[getViewsByCatagoryQueryNameForCategory(VIEW_CATEGORY_MINE)];
        if (!(currentViewsByCategory !== null && currentViewsByCategory !== void 0 && currentViewsByCategory.viewItems) || !(incoming !== null && incoming !== void 0 && incoming.id)) {
          return data;
        }
        return {
          [getViewsByCatagoryQueryNameForCategory(VIEW_CATEGORY_MINE)]: Object.assign({}, currentViewsByCategory, {
            total: currentViewsByCategory.total + 1,
            // Treat the incoming view as the "next page" of data coming in
            // and let the merge policy for SupportedCategories handle
            // merging it into the existing data
            viewItems: [incoming]
          })
        };
      });
      return incoming;
    }
  }
};
export const queryFieldPolicies = Object.assign({
  [VIEWS_SEARCH_QUERY_NAME]: {
    merge(__, incoming, {
      cache
    }) {
      incoming.results.forEach(view => {
        cache.writeQuery({
          data: {
            singleViewById: view
          },
          query: SingleViewByIdQuery,
          variables: {
            id: view.id,
            objectTypeId: view.objectTypeId,
            namespaceName: view.namespaceName
          }
        });
      });
      return incoming;
    }
  },
  [DEFAULT_PINNED_VIEWS_QUERY_NAME]: {
    merge(__, incoming, {
      cache
    }) {
      (incoming || []).forEach(view => {
        cache.writeQuery({
          data: {
            singleViewById: view
          },
          query: SingleViewByIdQuery,
          variables: {
            id: view.id,
            objectTypeId: view.objectTypeId,
            namespaceName: view.namespaceName
          }
        });
      });
      return incoming;
    }
  },
  [DEFAULT_PINNED_VIEW_QUERY_NAME]: {
    merge(__, incoming, {
      cache
    }) {
      cache.writeQuery({
        data: {
          singleViewById: incoming
        },
        query: SingleViewByIdQuery,
        variables: {
          id: incoming.id,
          objectTypeId: incoming.objectTypeId,
          namespaceName: incoming.namespaceName
        }
      });
      return incoming;
    }
  }
}, SupportedCategories.reduce((policies, category) => Object.assign({}, policies, {
  [getViewsByCatagoryQueryNameForCategory(category)]: {
    keyArgs: viewsByCategoryKeyArgs,
    merge(existing, incoming, {
      cache
    }) {
      (incoming && incoming.viewItems ? incoming.viewItems : []).forEach(view => {
        cache.writeQuery({
          data: {
            singleViewById: view
          },
          query: SingleViewByIdQuery,
          variables: {
            id: view.id,
            objectTypeId: view.objectTypeId,
            namespaceName: view.namespaceName
          }
        });
      });
      const uniqueMergedViewItems = mergeUnique({
        existing: existing === null || existing === void 0 ? void 0 : existing.viewItems,
        incoming: incoming === null || incoming === void 0 ? void 0 : incoming.viewItems
      });
      return Object.assign({}, incoming, {
        viewItems: uniqueMergedViewItems
      });
    }
  }
}), {}));